import { usingPost } from '@ocean/api'
import { AssessmentRecord } from 'modules/simulatorTrainings/instructor/studentLed/TrainingDetails/types'

export const assessSimulatorExerciseScheduleParticipants = (
  scheduleId: Guid,
  selectedAssessments: AssessmentRecord
) => {
  const assessments = Object.keys(selectedAssessments).map(userId => ({
    userId,
    status: selectedAssessments[userId],
  }))
  return usingPost('SimulatorTrainings/AssessSimulatorExerciseScheduleParticipants', {
    scheduleId,
    assessments,
  })
}
